// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
enum VehicleRegisterVehicleChangeOrigin {
  Unknown = "UNKNOWN",
  NewlyExemptedVehiclesSynchronization = "NEWLY_EXEMPTED_VEHICLES_SYNCHRONIZATION",
  VehicleChangesSynchronization = "VEHICLE_CHANGES_SYNCHRONIZATION",
  VehicleForChargeAdditionalSynchronization = "VEHICLE_FOR_CHARGE_ADDITIONAL_SYNCHRONIZATION",
  VehicleForExemptionAdditionalSynchronization = "VEHICLE_FOR_EXEMPTION_ADDITIONAL_SYNCHRONIZATION",
  VehicleForChargeImmediateSynchronization = "VEHICLE_FOR_CHARGE_IMMEDIATE_SYNCHRONIZATION",
  VehicleForExemptionImmediateSynchronization = "VEHICLE_FOR_EXEMPTION_IMMEDIATE_SYNCHRONIZATION",
  VehicleForBulkVehicleRegistrationChangeImmediateSynchronization = "VEHICLE_FOR_BULK_VEHICLE_REGISTRATION_CHANGE_IMMEDIATE_SYNCHRONIZATION",
  VehicleInstructionValidation = "VEHICLE_INSTRUCTION_VALIDATION",
  BackOfficeManualSynchronization = "BACK_OFFICE_MANUAL_SYNCHRONIZATION",
}
export default VehicleRegisterVehicleChangeOrigin;
